import { render, staticRenderFns } from "./DirectCostsTabs.vue?vue&type=template&id=1aa3b4ff&scoped=true"
import script from "./DirectCostsTabs.vue?vue&type=script&lang=js"
export * from "./DirectCostsTabs.vue?vue&type=script&lang=js"
import style0 from "./DirectCostsTabs.vue?vue&type=style&index=0&id=1aa3b4ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa3b4ff",
  null
  
)

export default component.exports